/** @format */

export default function OrientationFixer() {
    window.addEventListener("orientationchange", function () {
        // return () => gsap.kill();
        window.location.reload();
    });
}
